import React from 'react';
import DataTable from '../Components/DataTable';
import StatusBadge from '../Components/StatusBadge';
import FormattedDate from '../Components/FormattedDate';

function TablaCupones({ onSelectionChange, loading, error, onRetry, emptyStateNoReload, pageSize, currentPage, onPageChange, ...props }) {
    const { cupones = [] } = props;

    const columns = [
        {
            Header: 'ID',
            accessor: 'IdCupon',
        },
        {
            Header: 'Código',
            accessor: 'CodigoPromo',
            Cell: ({ value }) => (
                <span style={{ 
                    background: '#f0f0f0', 
                    padding: '4px 8px', 
                    borderRadius: '4px', 
                    fontFamily: 'monospace', 
                    fontWeight: '600',
                    fontSize: '13px'
                }}>
                    {value}
                </span>
            )
        },
        {
            Header: 'Descuento',
            accessor: 'PorcentajeDescuento',
            Cell: ({ value }) => (
                <span style={{ 
                    background: '#e8f5e8', 
                    color: '#2e7d32', 
                    padding: '4px 8px', 
                    borderRadius: '12px', 
                    fontSize: '12px', 
                    fontWeight: '600' 
                }}>
                    {value}% OFF
                </span>
            )
        },
        {
            Header: 'Empresa',
            accessor: 'Empresa',
            Cell: ({ value }) => (
                <div style={{ maxWidth: '150px', fontWeight: '500' }}>
                    {value && value.length > 20 ? `${value.substring(0, 20)}...` : value}
                </div>
            )
        },
        {
            Header: 'Descripción',
            accessor: 'Descripcion',
            Cell: ({ value }) => (
                <div title={value} style={{ maxWidth: '200px', fontSize: '12px' }}>
                    {value && value.length > 40 ? `${value.substring(0, 40)}...` : value}
                </div>
            )
        },
        {
            Header: 'Vencimiento',
            accessor: 'Fecha_fin',
            Cell: ({ value }) => <FormattedDate date={value} format="DD/MM/YYYY" />
        },
        {
            Header: 'Estado',
            accessor: 'EstatusCupon',
            Cell: ({ value }) => <StatusBadge status={value} />
        },
        {
            Header: 'Creado',
            accessor: 'Fecha_creacion',
            Cell: ({ value }) => <FormattedDate date={value} format="DD/MM/YYYY" />
        }
    ];

    return (
        <DataTable
            data={cupones}
            columns={columns}
            idField="IdCupon"
            onSelectionChange={onSelectionChange}
            loading={loading}
            error={error}
            onRetry={onRetry}
            emptyStateNoReload={emptyStateNoReload}
            emptyMessage="Datos no encontrados"
            className="tabla-cupones"
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={onPageChange}
        />
    );
}

export default TablaCupones;